import React from 'react';
import {
  Grid,
  ShimmerImage,
  Shadow,
  Cushion,
  ShimmerTypography,
  GridItem,
  MaxWidth,
} from '@pitchero/react-ui';
import PlaceholderProductCard from '../product-list/placeholder-card';

const PlaceholderProductPage = () => (
  <Cushion
    all="medium"
    vertical="xlarge"
    responsive={[
      { minWidth: 'tab', props: { all: 'xlarge' } },
      { minWidth: 'desk', props: { all: 'xxxlarge' } },
    ]}
    component="div"
  >
    <MaxWidth component="div" center maxWidth={920}>
      <Grid
        rowGap="medium"
        responsive={[
          { minWidth: 'tab', props: { columns: '300px 100fr', columnGap: 'xlarge' } },
          { minWidth: 'lap', props: { columns: '400px 450px', columnGap: 'xxxlarge' } },
        ]}
      >
        <Shadow shadow="dark">
          <ShimmerImage
            fullWidth
            hasLoaded={false}
            loadingAspectRatio={1}
            responsive={[
              { minWidth: 'tab', props: { width: '300px', height: '300px' } },
              { minWidth: 'lap', props: { width: '400px', height: '400px' } },
            ]}
          />
        </Shadow>
        <GridItem>
          <Grid rowGap="small" rows="auto auto 100fr">
            <ShimmerTypography preset="name" width="150px" />
            <ShimmerTypography preset="title--large" width="80%" />
            <GridItem>
              <ShimmerTypography lineHeight={25} size={10} />
              <ShimmerTypography lineHeight={25} size={10} />
              <ShimmerTypography lineHeight={25} size={10} width="50%" />
            </GridItem>
          </Grid>
        </GridItem>
      </Grid>
    </MaxWidth>
    <MaxWidth component="div" maxWidth={1366} center>
      <Cushion top="xlarge" bottom="medium" component="div">
        <ShimmerTypography preset="title" width="25%" />
      </Cushion>
      <Grid preset="productGrid">
        <PlaceholderProductCard />
        <PlaceholderProductCard />
        <PlaceholderProductCard />
        <PlaceholderProductCard />
      </Grid>
    </MaxWidth>
  </Cushion>
);

export default PlaceholderProductPage;
